import { OPERATORS } from '../constants';
import { Operator } from '../types';

type Values = string | number;
type ValuesArray = Array<Values>;

export const compareValues = (
    leftValue: Values,
    operator: Operator,
    rightValue: Values
): boolean => {
    if (operator === OPERATORS.EQUAL) {
        return leftValue === rightValue;
    }

    if (operator === OPERATORS.NOT_EQUAL) {
        return leftValue !== rightValue;
    }

    if (operator === OPERATORS.GREATER_THAN) {
        return leftValue > rightValue;
    }

    if (operator === OPERATORS.GREATER_THAN_OR_EQUAL) {
        return leftValue >= rightValue;
    }

    if (operator === OPERATORS.LESS_THAN) {
        return leftValue < rightValue;
    }

    if (operator === OPERATORS.LESS_THAN_OR_EQUAL) {
        return leftValue <= rightValue;
    }

    return true;
};

export const compareValuesArray = (
    leftValues: ValuesArray,
    operator: Operator,
    rightValues: ValuesArray
): boolean => {
    if (operator === OPERATORS.EQUAL) {
        return leftValues.some(v => rightValues.includes(v));
    }

    if (operator === OPERATORS.NOT_EQUAL) {
        return !leftValues.some(v => rightValues.includes(v));
    }

    if (operator === OPERATORS.GREATER_THAN) {
        return leftValues.some(v => rightValues.some(i => i > v));
    }

    if (operator === OPERATORS.GREATER_THAN_OR_EQUAL) {
        return leftValues.some(v => rightValues.some(i => i >= v));
    }

    if (operator === OPERATORS.LESS_THAN) {
        return leftValues.some(v => rightValues.some(i => i < v));
    }

    if (operator === OPERATORS.LESS_THAN_OR_EQUAL) {
        return leftValues.some(v => rightValues.some(i => i <= v));
    }

    return true;
};



// WEBPACK FOOTER //
// ./src/utils/compareValues.ts